import { rvkworkClient } from "@/compose";

function downloadFile(blob, fileName) {
  let anchor = document.createElement("a");
  anchor.href = URL.createObjectURL(blob);
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
}

function initial() {
  return {
    newTasks: null,
    openTasks: null,
    uploadedTasks: null,
    finishedTasks: null
  };
}

export default {
  state: initial(),
  getters: {
    newTasks: state => state.newTasks,
    openTasks: state => state.openTasks,
    uploadedTasks: state => state.uploadedTasks,
    finishedTasks: state => state.finishedTasks
  },
  mutations: {
    reset(state) {
      Object.assign(state, initial());
    },

    updateNewTasks(state, tasks) {
      state.newTasks = tasks;
    },
    updateOpenTasks(state, tasks) {
      state.openTasks = tasks;
    },
    updateUploadedTasks(state, tasks) {
      state.uploadedTasks = tasks;
    },
    updateFinishedTasks(state, tasks) {
      state.finishedTasks = tasks;
    }
  },
  actions: {
    loadNewTasks(context) {
      rvkworkClient.getOpenFilesForUserUsingGET().subscribe(response =>
        context.commit(
          "updateNewTasks",
          response.map(task => ({
            taskId: task.orderID,
            file1Name: task.vorschlagFileName,
            file2Name: task.auftragFileName,
            file3Name: task.agreementFileName
          }))
        )
      );
    },
    loadOpenTasks(context) {
      rvkworkClient.openOrdersForUserUsingGET().subscribe(response =>
        context.commit(
          "updateOpenTasks",
          response.map(task => ({
            taskId: task.orderID,
            file1Name: task.vorschlagFileName,
            file2Name: task.auftragFileName,
            file3Name: task.agreementFileName,
            returnFile1Name: task.customerVorschlagFileName,
            returnFile2Name: task.customerAuftragFileName,
            returnFile3Name: task.customerAgreementFileName
          }))
        )
      );
    },
    loadUploadedTasks(context) {
      rvkworkClient.openUserOrdersUsingGET().subscribe(response =>
        context.commit(
          "updateUploadedTasks",
          response.map(task => ({
            taskId: task.orderID,
            file1Name: task.vorschlagFileName,
            file2Name: task.auftragFileName,
            file3Name: task.agreementFileName,
            state:
              task.statusauftrag === task.statusvorschlag
                ? task.statusauftrag
                : "NEW",
            date: new Date(task.uploaded)
          }))
        )
      );
    },
    loadFinishedTasks(context) {
      rvkworkClient.getClosedOrdersCustomerUsingGET().subscribe(response =>
        context.commit(
          "updateFinishedTasks",
          response.map(task => ({
            taskId: task.orderID,
            file1Name: task.vorschlagFileName,
            file2Name: task.auftragFileName,
            file3Name: task.agreementFileName,
            date: new Date(task.lastAction)
          }))
        )
      );
    },

    downloadNewTaskFile(context, { task, fileIdx }) {
      const fileName = [task.file1Name, task.file2Name, task.file3Name][
        fileIdx
      ];
      rvkworkClient
        .downloadUserFileBodyUsingPOST({ orderID: task.taskId, fileName })
        .subscribe(blob => downloadFile(blob, fileName));
    },
    uploadReturnFiles(context, { task, file1, file2, file3 }) {
      return rvkworkClient
        .userFilesUsingPOST(file3, file2, task.taskId, file1)
        .toPromise();
    },
    returnTask(context, taskId) {
      return rvkworkClient
        .approvedUserFilesUsingPOST(taskId)
        .toPromise()
        .then(response => {
          context.dispatch("loadOpenTasks");
          return response;
        });
    },
    resetReturnFiles(context, taskId) {
      return rvkworkClient.abortUploadUsingDELETE(taskId).toPromise();
    }
  }
};
